import { Outlet } from "react-router-dom";
import { AdminHeader } from "../admin/components/global/AdminHeader";
import { AdminSidebar } from "../admin/components/global/AdminSidebar";
import { useState } from "react";
import { OrdersContextProvider } from "../contexts/OrdersContext";
import "./adminLayout.css"

export function AdminLayout() {
    const [sidebarDisplay, setSidebarDisplay] = useState(false)

    return (
        <div className="admin-wrapper">
            <AdminHeader
                sidebarDisplay={sidebarDisplay}
                setSidebarDisplay={setSidebarDisplay}
            />
            <div className="d-flex main-content">
                <AdminSidebar sidebarDisplay={sidebarDisplay} />

                <OrdersContextProvider>
                    <div className="outlet pt-5 px-2 px-sm-4 mb-5 w-100">
                        <Outlet />
                    </div>
                </OrdersContextProvider>
            </div>
        </div>
    )
}